import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-ui-icon',
  templateUrl: './ui-icon.component.html',
  styleUrls: ['./ui-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'inline-flex items-center justify-center',
  },
  imports: [NgClass],
})
export class UiIconComponent {
  @Input()
  name: string = '';

  @Input()
  @HostBinding('class')
  size: 'sm' | 'md' | 'lg' = 'md';

  @Input()
  color: string;
}
